import styled from "styled-components/native";

export const ContainerBorder = styled.View`
  margin-bottom: 15px;
  padding: 15px;
  border-bottom-color: #dddddd;
  border-bottom-width: 1px;
`;
